// custom-product-details.js — Capa visual del PDP (variantes, miniaturas vertical, barra sticky, etc.)
(function () {
  'use strict';
  if (!document.querySelector('.pdp-custom-layout')) return;

  // --- Selectores visuales de variante -> select oculto ---
  var variantsEl = document.querySelector('[data-pdp-variants]');
  var nativeSelect = document.getElementById('variant-selector');
  if (variantsEl && nativeSelect) {
    var VARIANTS = JSON.parse(variantsEl.getAttribute('data-pdp-variants') || '[]');
    var selected = {};
    document.querySelectorAll('.pdp-custom-swatch.is-active, .pdp-custom-pill.is-active').forEach(function (el) {
      selected[el.getAttribute('data-option-position')] = el.getAttribute('data-value');
    });

    var addButtons = [document.getElementById('addToCartButton'), document.getElementById('pdpStickyAdd')]
      .filter(Boolean)
      .map(function (btn) { var lbl = btn.querySelector('span') || btn; return { btn: btn, lbl: lbl, text: lbl.textContent }; });

    var setPurchasable = function (v) {
      var ok = !!(v && v.available);
      addButtons.forEach(function (o) {
        o.btn.disabled = !ok;
        o.btn.classList.toggle('is-unavailable', !ok);
        o.btn.setAttribute('aria-disabled', String(!ok));
        o.lbl.textContent = ok ? o.text : 'Agotado';
      });
    };

    var exactMatch = function () {
      return VARIANTS.find(function (v) {
        return Object.keys(selected).every(function (pos) { return v.options[parseInt(pos, 10) - 1] === selected[pos]; });
      });
    };

    var resolveVariant = function (changedPos) {
      var exact = exactMatch();
      if (exact) return exact;
      var pool = VARIANTS.filter(function (v) { return v.options[parseInt(changedPos, 10) - 1] === selected[changedPos]; });
      if (!pool.length) pool = VARIANTS.slice();
      return pool.filter(function (v) { return v.available; })[0] || pool[0];
    };

    var syncTo = function (v) {
      document.querySelectorAll('.pdp-custom-option').forEach(function (optEl) {
        var choices = optEl.querySelector('.pdp-custom-option-choices');
        var lblEl = optEl.querySelector('.pdp-custom-option-value');
        var pos = lblEl ? lblEl.getAttribute('data-opt-value') : null;
        if (!pos) return;
        var val = v.options[parseInt(pos, 10) - 1];
        selected[pos] = val;
        if (lblEl) lblEl.textContent = val;
        choices.querySelectorAll('.pdp-custom-swatch, .pdp-custom-pill').forEach(function (x) {
          x.classList.toggle('is-active', x.getAttribute('data-value') === val);
        });
      });
    };

    var isValueAvailable = function (pos, val) {
      pos = parseInt(pos, 10);
      return VARIANTS.some(function (v) {
        if (!v.available) return false;
        if (v.options[pos - 1] !== val) return false;
        for (var p = 1; p < pos; p++) {
          if (selected[p] != null && v.options[p - 1] !== selected[p]) return false;
        }
        return true;
      });
    };

    var updateAvailability = function () {
      document.querySelectorAll('.pdp-custom-swatch, .pdp-custom-pill').forEach(function (el) {
        var pos = el.getAttribute('data-option-position');
        var val = el.getAttribute('data-value');
        var ok = isValueAvailable(pos, val);
        el.disabled = !ok;
        el.classList.toggle('is-unavailable', !ok);
      });
    };

    var commitVariant = function (v) {
      if (!v) return;
      syncTo(v);
      nativeSelect.value = v.id;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      var hidden = document.getElementById('product-variant-id'); if (hidden) hidden.value = v.id;
      var sv = document.getElementById('pdpStickyVariant'); if (sv) sv.value = v.id;
      updateAvailability();
      setPurchasable(v);
      document.dispatchEvent(new CustomEvent('pdp:variant', { detail: { variant: v } }));
    };

    var apply = function (changedPos) {
      commitVariant(resolveVariant(changedPos));
    };

    document.querySelectorAll('.pdp-custom-swatch, .pdp-custom-pill').forEach(function (el) {
      el.addEventListener('click', function () {
        if (el.disabled) return;
        var pos = el.getAttribute('data-option-position');
        selected[pos] = el.getAttribute('data-value');
        el.closest('.pdp-custom-option-choices').querySelectorAll('.pdp-custom-swatch, .pdp-custom-pill').forEach(function (x) { x.classList.remove('is-active'); });
        el.classList.add('is-active');
        apply(pos);
        if (window.pulseCTA) {
          window.pulseCTA(document.getElementById('addToCartButton'));
          window.pulseCTA(document.getElementById('pdpStickyAdd'));
        }
      });
    });

    var stickyVariantSel = document.getElementById('pdpStickyVariant');
    if (stickyVariantSel) {
      stickyVariantSel.addEventListener('change', function () {
        var v = VARIANTS.find(function (x) { return String(x.id) === String(stickyVariantSel.value); });
        if (!v) return;
        commitVariant(v);
        if (window.pulseCTA) {
          window.pulseCTA(document.getElementById('pdpStickyAdd'));
          window.pulseCTA(document.getElementById('addToCartButton'));
        }
      });
    }
    updateAvailability();
    setPurchasable(exactMatch());
  }

  // --- Barra Sticky de Compra ---
  var bar = document.getElementById('pdpStickyBar');
  var buyBox = document.getElementById('pdpBuyBox');
  var trigger = document.getElementById('addToCartButton') || buyBox;
  if (bar && trigger) {
    var setBar = function (show) {
      bar.classList.toggle('is-visible', show);
      bar.style.setProperty('transform', show ? 'translateY(0)' : 'translateY(110%)', 'important');
    };
    var updateBar = function () {
      var rect = trigger.getBoundingClientRect();
      setBar(rect.bottom < window.innerHeight * 0.6);
    };
    setBar(false);
    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    updateBar();
  }

  var stickyAdd = document.getElementById('pdpStickyAdd');
  var mainAdd = document.getElementById('addToCartButton');
  if (stickyAdd && mainAdd) {
    stickyAdd.addEventListener('click', function () { mainAdd.click(); });
  }

  // Cantidad de la barra sticky
  var stQtyInput = document.getElementById('quantity');
  var stQtyNum = document.getElementById('pdpStickyQty');
  var syncStickyQty = function () { if (stQtyNum && stQtyInput) stQtyNum.textContent = stQtyInput.value || 1; };
  var stQtyMinus = document.getElementById('pdpStickyQtyMinus');
  var stQtyPlus = document.getElementById('pdpStickyQtyPlus');
  if (stQtyMinus && stQtyInput) stQtyMinus.addEventListener('click', function () { var n = parseInt(stQtyInput.value, 10) || 1; if (n > 1) { stQtyInput.value = n - 1; stQtyInput.dispatchEvent(new Event('change', { bubbles: true })); syncStickyQty(); } });
  if (stQtyPlus && stQtyInput) stQtyPlus.addEventListener('click', function () { var n = parseInt(stQtyInput.value, 10) || 1; stQtyInput.value = n + 1; stQtyInput.dispatchEvent(new Event('change', { bubbles: true })); syncStickyQty(); });
  if (stQtyInput) stQtyInput.addEventListener('change', syncStickyQty);
  syncStickyQty();

  // Mantener precio y stock de la barra sticky sincronizados
  var stickyPrice = document.getElementById('pdpStickyPrice');
  document.addEventListener('pdp:variant', function (ev) {
    var v = ev.detail && ev.detail.variant;
    if (!v) return;
    if (stickyPrice) {
      var priceEl = document.querySelector('.product-data__price--sale');
      if (priceEl) stickyPrice.textContent = priceEl.textContent.trim();
    }
    var stockEl = document.getElementById('pdpStockCount');
    if (stockEl && v.inventory_quantity != null) stockEl.textContent = v.inventory_quantity;

    // Actualizar precio de los simuladores de crédito personalizados
    if (v.price) {
      window.currentProductPrice = v.price / 100;
      if (typeof window.updateFinanceSimulator === 'function') {
        window.updateFinanceSimulator(window.currentProductPrice);
      }
    }
  });

  // --- Botón de Comprar Ahora ---
  var buyNow = document.getElementById('buyNowButton');
  if (buyNow) {
    buyNow.addEventListener('click', function () {
      var hidden = document.getElementById('product-variant-id');
      var qtyEl = document.getElementById('quantity');
      var id = hidden ? hidden.value : null;
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      if (!id) return;
      buyNow.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      }).catch(function () {
        buyNow.disabled = false;
        window.location.href = '/cart';
      });
    });
  }

  // --- Sincronizar aviso de añadido ---
  (function unifyAddFeedback() {
    ['addToCartButton', 'pdpStickyAdd'].forEach(function (id) {
      var b = document.getElementById(id);
      if (!b) return;
      b.addEventListener('click', function () {
        var mc = document.querySelector('.mini-cart--shop');
        if (mc) mc.classList.add('visible');
        document.dispatchEvent(new CustomEvent('cart:adding'));
      });
    });
    var toast = document.querySelector('.product-added');
    if (!toast) return;
    var obs = new MutationObserver(function () {
      if (!toast.classList.contains('added')) return;
      toast.classList.remove('added');
      var mc = document.querySelector('.mini-cart--shop');
      if (mc) mc.classList.add('visible');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    });
    obs.observe(toast, { attributes: true, attributeFilter: ['class'] });
  })();

  // --- Riel de miniaturas vertical ---
  (function initVThumbs(tries) {
    var thumbs = document.querySelectorAll('.pdp-custom-thumbs-list .pdp-custom-thumb-btn');
    if (!thumbs.length) return;
    if (!window.swiper2 || !window.swiper2.slideToLoop) {
      if (tries > 0) setTimeout(function () { initVThumbs(tries - 1); }, 100);
      return;
    }
    var sw = window.swiper2;
    var rail = document.querySelector('.pdp-custom-thumbs-list');

    var goToReal = function (i) {
      var slides = Array.prototype.slice.call(document.querySelectorAll('.mySwiper2 .swiper-slide'));
      var el = slides.filter(function (s) {
        return s.getAttribute('data-swiper-slide-index') === String(i) && !s.classList.contains('swiper-slide-duplicate');
      })[0];
      var domIndex = el ? slides.indexOf(el) : i;
      if (domIndex >= 0 && sw.slideTo) sw.slideTo(domIndex);
    };
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToReal(parseInt(btn.getAttribute('data-index'), 10) || 0);
      });
    });
    var syncActive = function () {
      var real = sw.realIndex || 0;
      thumbs.forEach(function (b) {
        var active = parseInt(b.getAttribute('data-index'), 10) === real;
        b.classList.toggle('is-active', active);
        if (active && rail) {
          var top = b.offsetTop - rail.offsetTop;
          if (top < rail.scrollTop) rail.scrollTop = top;
          else if (top + b.offsetHeight > rail.scrollTop + rail.clientHeight) rail.scrollTop = top + b.offsetHeight - rail.clientHeight;
        }
      });
    };
    if (sw.on) sw.on('slideChange', syncActive);
    syncActive();

    var wrap = document.querySelector('.pdp-custom-thumbs-container');
    var moreBtn = wrap ? wrap.querySelector('.pdp-custom-thumbs-more') : null;
    if (wrap && rail) {
      var updateFades = function () {
        var canDown = rail.scrollTop + rail.clientHeight < rail.scrollHeight - 2;
        var canUp = rail.scrollTop > 2;
        wrap.classList.toggle('has-more', canDown);
        wrap.classList.toggle('has-prev', canUp);
      };
      rail.addEventListener('scroll', updateFades, { passive: true });
      window.addEventListener('resize', updateFades);
      if (moreBtn) moreBtn.addEventListener('click', function () { rail.scrollBy({ top: rail.clientHeight * 0.6, behavior: 'smooth' }); });
      setTimeout(updateFades, 300);
      updateFades();
    }
  })(40);

})();
